import { differenceInDays, isSameDay } from 'date-fns'

export type QuickRangePreset = '24h' | '30d' | '365d'

export const QUICK_RANGE_LABELS: Record<QuickRangePreset, string> = {
  '24h': 'Last 24 hours',
  '30d': 'Last 30 days',
  '365d': 'Last 365 days'
}

const secondsInDay = 60 * 60 * 24

const QUICK_RANGE_SECONDS: Record<QuickRangePreset, number> = {
  '24h': secondsInDay,
  '30d': secondsInDay * 30,
  '365d': secondsInDay * 365
}

export const startOfDay = (date: Date): Date => {
  const d = new Date(date)
  d.setHours(0, 0, 0, 0)
  return d
}

export const endOfDay = (date: Date): Date => {
  const d = new Date(date)
  d.setHours(23, 59, 59, 999)
  return d
}

export const getQuickRange = (preset: QuickRangePreset, now = new Date()): { startDate: Date, endDate: Date } => {
  const ms = QUICK_RANGE_SECONDS[preset] * 1000
  if (preset === '24h') return { startDate: new Date(now.getTime() - ms), endDate: now }
  return { startDate: new Date(startOfDay(now).getTime() - ms), endDate: endOfDay(now) }
}

export const getQuickRangePreset = (start: Date, end: Date): QuickRangePreset | undefined => {
  if (!isSameDay(end, new Date())) return undefined
  if (end.getTime() - start.getTime() === QUICK_RANGE_SECONDS['24h'] * 1000) return '24h'
  const days = differenceInDays(end, start)
  if (days === 30) return '30d'
  if (days === 365) return '365d'
  return undefined
}
